<template>
  <div class="text-center">
    <div class="inline-block size-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
      <div class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">{{ t('common.loading') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
